import { ContactInformation } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDriverInfo/driverInfoQuery.type';
import { contactOwnerInitialVisitFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchContactOwnerInitialVisit/patchContactDriverQueryFunctions';
import { useMutation } from '@tanstack/react-query';

export const useContactOwnerInitialVisitQuery = () => {
  return useMutation({
    mutationFn: (params: { data: ContactInformation; fileId: string }) =>
      contactOwnerInitialVisitFunction(params),
    mutationKey: ['useContactOwnerInitialVisitQuery'],
  });
};
